
import { FC } from 'react';

import './Loader.scss';

export type Props = {
    text?: string;
};

export const Loader = () => {
    return(
        <div className="c-loader">
            <div className="c-loader__group">
                <span className="c-loader--1"></span>
                <span className="c-loader--2"></span>
            </div>
            <div className="c-loader__group">
                <span className="c-loader--3"></span>
                <span className="c-loader--4"></span>
            </div>
        </div>

    );
};

